import { Phone, Mail, MapPin, Calendar, Wrench, User, Trash2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";
import { STATUS, SERVICE, fmt } from "./constants";

const Row = ({ icon: Icon, label, children, testid }) => (
  <div className="flex gap-3 border-b border-white/5 py-3">
    <Icon className="mt-0.5 h-4 w-4 shrink-0 text-[#00E676]" />
    <div className="min-w-0">
      <p className="font-mono text-[11px] uppercase tracking-[0.15em] text-zinc-400">{label}</p>
      <div className="mt-1 break-words text-white" data-testid={testid}>{children}</div>
    </div>
  </div>
);

export const QuoteDetails = ({ q, onClose, onStatus, onDelete }) => (
  <Dialog open={!!q} onOpenChange={(o) => !o && onClose()}>
    <DialogContent className="max-h-[90vh] overflow-y-auto border-emerald-500/25 bg-[#0C1210] text-white sm:max-w-lg" data-testid="quote-details-dialog">
      {q && (
        <>
          <DialogHeader>
            <DialogTitle className="font-display text-2xl font-extrabold text-white">{q.name}</DialogTitle>
            <DialogDescription className="text-zinc-400">Στοιχεία αιτήματος</DialogDescription>
          </DialogHeader>
          <div>
            <Row icon={Calendar} label="Ημερομηνία" testid="details-date">{fmt(q.created_at)}</Row>
            <Row icon={User} label="Ονοματεπώνυμο" testid="details-name">{q.name}</Row>
            <Row icon={Phone} label="Τηλέφωνο" testid="details-phone"><a href={`tel:${q.phone}`} className="text-[#00E676]">{q.phone}</a></Row>
            <Row icon={Mail} label="Email" testid="details-email">{q.email ? <a href={`mailto:${q.email}`} className="text-[#00E676]">{q.email}</a> : "—"}</Row>
            <Row icon={MapPin} label="Περιοχή / Πόλη" testid="details-area">{q.area}</Row>
            <Row icon={Wrench} label="Υπηρεσία" testid="details-service">{SERVICE[q.service] || q.service}</Row>
            <div className="py-3">
              <p className="font-mono text-[11px] uppercase tracking-[0.15em] text-zinc-400">Περιγραφή εργασίας</p>
              <p className="mt-1 whitespace-pre-line leading-relaxed text-zinc-200" data-testid="details-message">{q.message}</p>
            </div>
          </div>
          <div>
            <p className="mb-2 font-mono text-[11px] uppercase tracking-[0.15em] text-zinc-400">Κατάσταση</p>
            <div className="flex flex-wrap gap-2">
              {Object.entries(STATUS).map(([k, v]) => (
                <button key={k} onClick={() => onStatus(q.id, k)} disabled={q.status === k} data-testid={`details-set-${k}`}
                  className={`rounded-full border px-3 py-1.5 text-xs font-semibold transition-colors ${q.status === k ? "border-transparent " + v.cls : "border-emerald-500/25 text-zinc-300 hover:border-emerald-400 hover:text-white"}`}>
                  {v.label}
                </button>
              ))}
            </div>
          </div>
          <a href={`tel:${q.phone}`} className="btn-primary btn-lg mt-2 justify-center" data-testid="details-call-btn"><Phone className="h-5 w-5" />Κλήση πελάτη</a>
          <button onClick={() => onDelete(q.id)} className="flex items-center justify-center gap-2 rounded-full border border-red-500/40 py-3 text-sm font-semibold text-red-300 transition-colors hover:bg-red-500/10" data-testid="details-delete-btn"><Trash2 className="h-4 w-4" />Διαγραφή αιτήματος</button>
        </>
      )}
    </DialogContent>
  </Dialog>
);
